import { Tab, TabGroup } from '@nike/eds'
import { ExportButton } from '../../common/components/export/ExportButton'
import { shipmentMaterialsXlsxColumns } from './ShipmentMaterialsXlsxColumns'
import {
  GetShipmentMaterialsDocument,
  SearchShipmentsWithGoodsHoldersForExportDocument,
} from '../../generated/graphql'
import { useState } from 'react'
import { GoodsHoldersTable } from './GoodsHoldersTable'
import { ShipmentMaterialsTable } from './ShipmentMaterialsTable'
import { shipmentByGoodsHolderXlsxColumns } from '../shipment/search/ShipmentsXlsxColumns'
import { get } from '../../common/components/properties/Properties'

export function GoodsHoldersTabs({ packlistNumber, shippingPointCode }) {
  const [activeTab, setActiveTab] = useState('tab-cartons')
  return (
    <div>
      <div className="table-title-row" style={{ marginBottom: 'var(--eds-space-8)' }}>
        <TabGroup
          name="tab-group"
          activeId={activeTab}
          onChange={(e) => setActiveTab(e.target.id)}
          className="table-title"
        >
          <Tab id="tab-cartons" className="eds-type--title-3">
            Cartons
          </Tab>
          <Tab id="tab-materials" className="eds-type--title-3">
            Materials
          </Tab>
        </TabGroup>
        {activeTab === 'tab-cartons' && (
          <ExportButton
            className="table-export-button"
            xlsxColumns={shipmentByGoodsHolderXlsxColumns}
            exportQuery={{
              query: SearchShipmentsWithGoodsHoldersForExportDocument,
              variables: {
                packlistNumbers: [packlistNumber],
                shippingPointCodes: [shippingPointCode],
              },
              name: 'searchShipmentsWithGoodsHolders',
              action: 'exportCartons',
            }}
            pageSize={1}
            format={mapShipmentsByGoodsHolder}
            fileName={`cartons-${packlistNumber}.xlsx`}
          />
        )}
        {activeTab === 'tab-materials' && (
          <ExportButton
            className="table-export-button"
            xlsxColumns={shipmentMaterialsXlsxColumns(packlistNumber)}
            exportQuery={{
              query: GetShipmentMaterialsDocument,
              variables: { packlistNumber },
              name: 'getShipmentMaterials',
              action: 'exportMaterials',
            }}
            fileName={`materials-${packlistNumber}.xlsx`}
          />
        )}
      </div>
      {activeTab === 'tab-cartons' && <GoodsHoldersTable packlistNumber={packlistNumber} />}
      {activeTab === 'tab-materials' && <ShipmentMaterialsTable packlistNumber={packlistNumber} />}
    </div>
  )
}

function mapShipmentsByGoodsHolder(data) {
  let newData = []
  data.forEach((shipment) => {
    const goodsHolders = get(shipment, 'goodsHolders') || []
    goodsHolders.forEach((gh) =>
      newData.push({
        goodsHolderNumber: gh.goodsHolderNumber,
        goodsHolderTrackingNumber: gh.goodsHolderTrackingNumber,
        calculatedGoodsHolderStatusCode: gh.calculatedGoodsHolderStatusCode,
        salesOrderNumber: gh.salesOrderNumber,
        purchaseOrderNumber: gh.purchaseOrderNumber,
        deliveryNoteNumber: get(gh, 'goodsHolderItems.deliveryNoteNumber'),
        calculatedPlannedQuantity: gh.calculatedPlannedQuantity,
        calculatedPackedQuantity: gh.calculatedPackedQuantity,
        goodsHolderMeasures: gh.goodsHolderMeasures,
        transportHolder: gh.transportHolder,
        ...shipment,
      })
    )
  })
  return newData
}
